import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css';

// Import Swiper styles
import './index.css';
import { Provider } from 'react-redux';
import { createTheme, ThemeProvider } from '@mui/material';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store';
import color from './config/color';

const theme = createTheme({
  palette: {
    primary: {
      main: color.primaryColor,
      contrastText: color.secondaryColor,

    },
    secondary: {
      main: color.secondaryColor,
    },
    black: {
      main: '#434343',
      contrastText: color.primaryColor,
    },
    linkedin: {
      main: '#0A66C2',
      contrastText: color.primaryColor,
    },
  },
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>

      <Provider store={store}>
        <App />
      </Provider>
    </ThemeProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
